var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolidperformer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.651,
    height: 35.635,
    viewBox: "0 0 35.651 35.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1831",
    "data-name": "Group 1831",
    transform: "translate(0)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M161.475,61.792a26.071,26.071,0,0,0-5.881-3.3,31.3,31.3,0,0,0-23.537,0,26.035,26.035,0,0,0-5.881,3.3.446.446,0,0,0-.176.35c0,.2-.006,20.511,17.576,29.642a.45.45,0,0,0,.205.05h.088a.451.451,0,0,0,.205-.05c17.582-9.13,17.578-29.437,17.575-29.642a.446.446,0,0,0-.176-.35ZM143.826,90.908c-15.965-8.408-16.881-26.363-16.931-28.54a25.3,25.3,0,0,1,5.5-3.047,30.4,30.4,0,0,1,22.861,0,25.337,25.337,0,0,1,5.5,3.047c-.05,2.177-.966,20.133-16.931,28.54Z",
    transform: "translate(-126.001 -56.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M174.257,94.365a20.95,20.95,0,0,0-4.734,2.653.446.446,0,0,0-.176.351c0,.168,0,16.94,14.135,24.284a.45.45,0,0,0,.205.05h.071a.451.451,0,0,0,.205-.05C198.1,114.31,198.1,97.538,198.1,97.369a.445.445,0,0,0-.176-.351,21,21,0,0,0-4.734-2.653,25.18,25.18,0,0,0-18.932,0Zm9.466,26.407c-12.623-6.68-13.431-21.227-13.482-23.179a20.243,20.243,0,0,1,4.354-2.4,24.278,24.278,0,0,1,18.257,0,20.256,20.256,0,0,1,4.353,2.4c-.049,1.95-.846,16.492-13.481,23.178Z",
    transform: "translate(-165.897 -89.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M263.35,166.91a7.492,7.492,0,1,0,7.492,7.492A7.5,7.5,0,0,0,263.35,166.91Zm-4,12.727a3.981,3.981,0,0,1,2.837-3.726.445.445,0,0,0,.083-.818,2.455,2.455,0,1,1,2.28.029.446.446,0,0,0,.062.82,4,4,0,0,1,2.744,3.694,6.554,6.554,0,0,1-8.007,0Zm8.82-.738a4.881,4.881,0,0,0-2.5-3.469,3.343,3.343,0,1,0-4.523-.06,4.852,4.852,0,0,0-2.611,3.528,6.6,6.6,0,1,1,9.635,0Z",
    transform: "translate(-245.525 -158.1)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidperformer);
export default __webpack_public_path__ + "static/media/Solidperformer.80a68de5f78d9a00938dbbc9563ed64f.svg";
export { ForwardRef as ReactComponent };